// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xLFy","buttons":"styles_buttons__2TIF-"};